<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/yahya-goga.jpg" alt="Yahya Goga">
          </figure>
        <div class="finger-print">
          <img src="@/assets/images/fingerprints/fingerprint-six.svg" alt="">
        </div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Yahya Goga</h2>
      <p class="job-title">Senior Lecturer</p>

<p class="profile-statement-interviewer">Tell us a little bit about yourself</p>

<p>My parents are originally born and raised in India and moved to the UK. I’m the first generation born here. I actually grew up here and came to MMU as a student. I then went straight into education and taught in sixth form colleges for up to 12 years before making the jump into HE (higher education). I was born in Gloucester. A lot the families moved from India to Gloucester, as there was a lot of work there. I was born there and later moved to Manchester. We have a massive community; and most of my family is here.</p>

<p class="profile-statement-interviewer">What inspires you within your role?</p>

<p>Students. Their progress and wellbeing and helping them move on to the next stage in their education and journey.</p>

<p class="profile-statement-interviewer">What is something that you love about your culture or heritage?</p>

<p>The food, the language. I also love the humbleness, simplicity and the quality that some people have come from.</p>

<p>We very rarely speak our home language now because the kids speak English more. Mum and Dad speak English with my children and my grandma is here from India. I can talk to her, but I can’t express myself and articulate myself well. I can communicate in 4 languages, some better than others.</p>

<p class="profile-statement-interviewer">What does it look like to bring your whole self to your work? </p>


<p>My dress is my dress outside of work, I don’t change. I suppose I do talk about my cultural self where applicable, and I encourage others to talk about theirs. I do like to know about where people are from and things about their culture. I think it has to be natural and organic.</p>

<p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students? </p>

<p>Sometimes I think less is more. I think less looks like, that we’re represented, we’re part of the organisation MMU, we’re visible and just seeing people together; someone sitting with someone, someone sitting with someone else - it's just natural and it’s just organic.</p>

<p>I think one thing I’ve always been wary about is this whole tick box exercise. Someone gets something because of their ethnic background. It could be gender, ethnic background or religion. I think if it's pushed in people faces too much then it sometimes becomes central.</p>

<p>I’ve had comments in the past where white colleagues have said ‘If I got something, X ticks a box, you’ve got it because you fit their diversity criteria which they need to show’ And I suppose sometimes people can be resentful if there’s too much on that side.</p>

<p>I think students appreciate that. I do thinks it’s needed but I also think that getting the right staff in the classrooms and around university is important as well. The real interactions that students have on their own or in lectures halls or support staff. I think that’s really important</p>

<p class="profile-statement-interviewer">What are you most proud of?</p>

<p>I don’t know. I suppose that I’m proud that I’ve been a part of education since 2005. That’s 17 years. I suppose just being a part of someone’s life and contributing to someone’s life. I never wanted to sit in an office, be in a big company and earn loads of money, but if I can make a small difference in someone’s life, I suppose that, for me, is the most important thing - having a positive impact on someone’s life.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  .profile-container {
  flex-direction: row-reverse;
  }

  .profile-portrait-container {
    justify-content: flex-end;

     & figure {
      text-align: right;
    }
  }

</style>